import { useNavigate } from "react-router-dom";
import './transferServices.css'
const cities = [
  { name: "Dubai", slug: "dubai" },
  { name: "Abu Dhabi", slug: "abu-dhabi" },
  { name: "Sharjah", slug: "sharjah" },
  { name: "Fujairah", slug: "fujairah" },
  { name: "Al Ain", slug: "al-ain" },
  { name: "Ras Al Khaimah", slug: "ras-al-khaimah" },
];

const TransferServiceModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleClick = (slug) => {
    onClose();
    navigate(`/transfer-services/${slug}`);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>Select Transfer Service City</h3>

        <ul className="city-list">
          {cities.map((city) => (
            <li key={city.slug} onClick={() => handleClick(city.slug)}>
              {city.name}
            </li>
          ))}
        </ul>

        <button className="modal-close" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default TransferServiceModal;
